import { render, staticRenderFns } from "./GoodsCategory.vue?vue&type=template&id=f1c8ab0c&scoped=true&"
import script from "./GoodsCategory.vue?vue&type=script&lang=js&"
export * from "./GoodsCategory.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCategory.vue?vue&type=style&index=0&id=f1c8ab0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c8ab0c",
  null
  
)

export default component.exports